import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LIVE_SESSIONS_TRANSLATION_KEY } from "../constants";
var es = /*#__PURE__*/_defineProperty({}, LIVE_SESSIONS_TRANSLATION_KEY, {
  SEARCH_SESSION: 'Buscar sesión',
  CTA_UPDATE_SESSIONS_LIST: 'Actualizar',
  DATE_SESSIONS_HEADER_TODAY: 'Sesiones para hoy',
  DATE_SESSIONS_HEADER_TOMORROW: 'Mañana {{date}}',
  DATE_SESSIONS_CARD_GUESTS: '{{guests}} invitados',
  DATE_SESSIONS_CARD_GUESTS_plural: '{{guests}} invitados',
  NO_PAST_SESSIONS: 'No tienes ninguna sesión pasada',
  NO_UPCOMING_SESSIONS: 'No tienes ninguna sesión creada',
  NO_UPCOMING_SESSIONS_DESCRIPTION: 'Comienza a crear entornos de aprendizaje dinámicos para tus colaboradores',
  SESSION_CARD_CTA_DETAIL: 'Ver detalle',
  SESSION_CARD_CTA_EDIT: 'Editar sesión',
  SESSION_CARD_CTA_DELETE: 'Eliminar sesión',
  SESSION_CARD_LINK_PLACEHOLDER: 'Evento virtual',
  NO_RESULTS_FOUND: 'No se encontraron resultados para',
  SESSION_START_IN: 'Tu sesión comienza en {{min}} MIN',
  SESSION_LIVE_TAG: 'En curso',
  ON_LIVE: 'En vivo',
  GET_INTO: 'Ingresar',
  SESSION_IN_PROGRESS: 'En curso',
  NO_UPCOMING_SESSIONS_COLLABORATOR: 'No tienes sesiones agendadas por el momento',
  NO_PAST_SESSIONS_COLLABORATOR: 'No tienes sesiones pasadas por el momento',
  GUESTS_TABLE_TITLE: 'Participantes',
  GUESTS_TABLE_SUBTITLE: 'Aquí podrás ver todos los usuarios de la organización.',
  GUESTS_TABLE_SEARCH: 'Buscar por nombre, apellido o mail',
  GUESTS_TABLE_TOTAL_SELECTED_ACCEPT: 'seleccionado de esta página.',
  GUESTS_TABLE_TOTAL_SELECTED_CANCEL: 'seleccionado en total.',
  GUESTS_TABLE_FILTER: 'Filtrar por',
  GUESTS_TABLE_SELECT_ALL: 'Seleccionar los {{total}} items',
  GUESTS_TABLE_REMOVE_SELECTION: 'Anular selección',
  GUESTS_TABLE_COLUMN_NAME: 'Nombre',
  GUESTS_TABLE_COLUMN_MAIL: 'Mail',
  GUESTS_TABLE_COLUMN_ATTRIBUTES: 'Atributos',
  DELETE_SESSION_DIALOG_TITLE: '¿Deseas eliminar {{sessionTitle}}?',
  DELETE_SESSION_DIALOG_SUBTITLE: 'Al eliminar la sesión, ya no tendrás acceso a la misma',
  DELETE_SESSION_DIALOG_CANCEL: 'Cancelar',
  DELETE_SESSION_DIALOG_DELETE: 'Eliminar',
  BLOCKED_SCREEN_DEVELOPMENT: 'Desarrollo',
  BLOCKED_SCREEN_TITLE: 'Genera actividades en vivo con tu equipo',
  BLOCKED_SCREEN_SUBTITLE: 'Crea sesiones en vivo permitiendo una interacción en tiempo real y así fomentar un aprendizaje más participativo',
  BLOCKED_SCREEN_DEMO_CTA: 'Solicitar demo gratis',
  BLOCKED_SCREEN_DEMO_VIDEO: 'Ver video',
  BLOCKED_SCREEN_CARDS_TITLE: '¿Qué tendrás acceso?',
  BLOCKED_SCREEN_FIRST_CARD_TITLE: 'Programa sesiones en vivo',
  BLOCKED_SCREEN_FIRST_CARD_DESCRIPTION: 'Crea sesiones presenciales o virtuales, la invitación les llegará via mail a tus usuarios.',
  BLOCKED_SCREEN_SECOND_CARD_TITLE: 'Grabación de la sesión',
  BLOCKED_SCREEN_SECOND_CARD_DESCRIPTION: 'Carga la grabación y los archivos complementarios a tu sesión.',
  BLOCKED_SCREEN_THIRD_CARD_TITLE: 'Registra asistencia',
  BLOCKED_SCREEN_THIRD_CARD_DESCRIPTION: 'Lleva un registro de las personas que asistieron a tu sesión dentro de la plataforma.',
  BLOCKED_SCREEN_DEMO_DIALOG_TITLE: '¿Deseas solicitar una demo gratis de Elevate Plus?',
  BLOCKED_SCREEN_DEMO_DIALOG_SUBTITLE: 'Las funcionalidades de Elevate LXP están disponibles dentro del plan Elevate Plus. Solicita una demo y amplia tu plan para empezar a gestionar tu propio contenido.',
  BLOCKED_SCREEN_DEMO_DIALOG_CTA: 'Sí, solicitar',
  BLOCKED_SCREEN_DEMO_DIALOG_CANCEL: 'Cancelar',
  SESSIONS_LIST_ERROR_TITLE: 'Hubo un error en la carga de sesión',
  SESSIONS_LIST_ERROR_SUBTITLE: 'Haz clic en el botón para intentar cargar nuevamente.',
  SESSIONS_LIST_ERROR_CTA: 'Reintentar',
  NEW_LIVE_SESSION_TAG: 'Nueva sesión',
  GUEST_CARD_TITLE: 'Participantes',
  GUEST_TABLE_NAME_COLUMN: 'Name',
  GUEST_TABLE_CONFIRMATION_COLUMN: 'Confirmación',
  GUEST_TABLE_ACTIONS_COLUMN: 'Acciones',
  GUEST_CARD_SEARCH: 'Buscar',
  GUEST_CARD_NO_GUEST_TITLE: 'Aún no has añadido participantes',
  GUEST_CARD_NO_GUEST_SUBTITLE: 'Recuerda hacerlo para que podamos enviarles la notificación',
  GUESTS_TABLE_ASSIST_CTA: 'Asistieron',
  GUEST_TABLE_ASSISTANCE_COLUMN: 'Asistencia',
  TOOLTIP_CONFIRMED_PARTICIPANTS_COUNT: 'Confirmados',
  TOOLTIP_INVITED_COUNT: 'Invitados',
  TOOLTIP_ADD_PARTICIPANTS_CTA: 'Agregar participantes',
  TOOLTIP_CANT_REMOVE_PARTICIPANT: 'No puedes eliminar participantes confirmados',
  TOOLTIP_ASSIST_COUNT: 'Asistidos',
  TOOLTIP_ASSIST_BUTTON: 'Selecciona quienes han participado para marcarlos como asistidos',
  TOOLTIP_NO_PRESENT_ACTION: 'Debes dar presente al usuario para acceder a más acciones',
  COPY_LINK: 'Copiar link',
  VIRTUAL: 'Virtual',
  PRESENTIAL: 'Presencial',
  SESSION_IN_COURSE_TAG: 'Sesión como clase'
});
export default es;